import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { TooltipProvider } from "~/components/ui/tooltip";
import { ConfirmProvider } from "~/components/confirm-dialog";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <TooltipProvider delayDuration={200}>
      <ConfirmProvider>
        <Outlet />
      </ConfirmProvider>
      <Toaster
        position="top-right"
        offset={16}
        gap={8}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast:
              "group/toast pointer-events-auto flex w-full items-start gap-2.5 rounded-lg border border-hairline bg-surface text-foreground shadow-xl shadow-foreground/10 px-3.5 py-3 text-[13px] tracking-[-0.005em]",
            title: "font-medium text-foreground",
            description: "text-text-faint text-[12px]",
            actionButton:
              "ml-auto inline-flex h-7 items-center rounded-md bg-primary px-2.5 text-[12px] font-medium text-primary-foreground hover:bg-primary/90",
            cancelButton:
              "ml-auto inline-flex h-7 items-center rounded-md bg-muted px-2.5 text-[12px] font-medium text-foreground hover:bg-accent",
            closeButton:
              "absolute right-1.5 top-1.5 text-text-faint hover:text-foreground transition-colors size-6 rounded-md inline-flex items-center justify-center",
            success:
              "[&_[data-icon]]:text-[oklch(0.55_0.16_145)] dark:[&_[data-icon]]:text-[oklch(0.78_0.17_145)]",
            error: "[&_[data-icon]]:text-destructive",
            info: "[&_[data-icon]]:text-text-faint",
            icon: "shrink-0 mt-0.5 [&>svg]:size-3.5",
            content: "min-w-0 flex-1 space-y-0.5",
          },
        }}
      />
    </TooltipProvider>
  );
}
